"use client";
import { useEffect } from "react";
import { captureException } from "@sentry/nextjs";

import { ErrorPageNavBar } from "@portal/app/_components/ui-elements/CustomerNavBar/ErrorPageNavBar";
import { Layout } from "@portal/app/_components/ui-elements/Layout";
import { DreamMuiHandledErrorRefresh } from "@portal/app/_components/ui-elements/Mui/DreamMuiHandledError";

export const ServerErrorPage = ({ error }: { error?: Error }) => {
  useEffect(() => {
    if (error) {
      captureException(error);
    }
  }, [error]);

  return (
    <Layout nav={<ErrorPageNavBar />}>
      <DreamMuiHandledErrorRefresh
        title="We're sorry, something went wrong"
        content="If you followed a link, it might have been to a page that moved or doesn't exist
          anymore. Sorry about that!"
      />
    </Layout>
  );
};
